import styled from 'styled-components';

import { getInAnimationIn, getInAnimationOut } from './animations';

export const Container = styled.section`
  animation: 1s
    ${({ animation, show }) =>
      show ? getInAnimationIn(animation) : getInAnimationOut(animation)};
  position: relative;

  ${({ isText }) =>
    isText &&
    `
      align-items: center;
      display: flex;
      justify-content: center;
      width: 100%;
  `}
`;
Container.displayName = 'Container';

export const Image = styled.img`
  width: 100%;
`;
Image.displayName = 'Image';

export const Text = styled.p`
  color: #000000;
  font-family: 'Noto Sans', sans-serif;
  font-size: 80px;
  line-height: 100px;
  margin: 0;
  max-width: 800px;
  text-align: center;
  white-space: pre-wrap;

  ${({ hasText }) =>
    hasText &&
    `
      position: absolute;
  `}
`;
Text.displayName = 'Text';
